import React from 'react';
import styled from 'styled-components';
import { variant, background, layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Meta } from './CardMeta';
import { computeFixedCoverStyle, getHeaderVariant } from './utils/responsiveProps';

const cardWrapperStyle = variant({
  key: 'card.wrapper',
});

const Wrapper = styled.a`
  ${layout}
  ${cardWrapperStyle}
  position: relative;
  display: flex;
  overflow: hidden;
  box-shadow: ${themeGet('card.boxShadow')};
  background-color: ${themeGet('card.backgroundColor')};
  border: ${themeGet('card.border')};
  border-radius: ${themeGet('card.borderRadius')};
  border-color: ${themeGet('card.borderColor')};
  text-decoration: none;
`;

const cardCoverStyle = variant({
  key: 'card.cover',
});

const Cover = styled.div`
  ${background}
  ${cardCoverStyle}
  ${layout}
  flex-shrink: ${({ flexShrink }) => flexShrink};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

const cardHeaderStyle = variant({
  key: 'card.header',
});

const Header = styled.div`
  ${cardHeaderStyle}
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  box-sizing: border-box;
`;

const cardContentStyle = variant({
  key: 'card.content',
});

const Container = styled.div`
  ${cardContentStyle}
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

const Footer = styled.div`
  flex: 0 0;
  border-top: ${themeGet('card.footer.borderTop')};
  border-color: ${themeGet('card.footer.borderColor')};
`;

export const Card = ({ width, coverUrl, variant, header, children, footer, fixedCoverSize, ...rest }) => (
  <Wrapper width={width} variant={variant} {...rest}>
    {coverUrl && (
      <Cover
        {...computeFixedCoverStyle(variant, fixedCoverSize)}
        flexShrink={fixedCoverSize == null ? 'initial' : 0}
        variant={variant}
        backgroundImage={`url(${coverUrl})`}
      />
    )}
    <Container>
      {header && <Header variant={getHeaderVariant(variant, !!coverUrl)}>{header}</Header>}
      {children}
      {footer && <Footer>{footer}</Footer>}
    </Container>
  </Wrapper>
);

Card.Meta = Meta;
